import Vue from 'vue'
// import Vuex from 'vuex'
import App from './App'
import Rs from 'vue-resource'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
// import Locales from '@/components/language/app.js'
import 'element-ui/lib/theme-default/index.css'
import router from './router'
import { baseurl } from './api/url.js'
import req from './api/req.js'

/*import 'font-awesome/css/font-awesome.css'*/

import Wrqs from '@/components/wRequester.js'
import WGMethods from '@/components/wGlobalMethods.js'


import store from './vuex/index'

require ('./assets/fontawesome470/css/font-awesome.min.css')

import ztApi from './api/api.js'

import axios from 'axios'
/*  create http client */
import './assets/css/zt.css'

import 'vue-croppa/dist/vue-croppa.css'
import Croppa from 'vue-croppa'

Vue.use(Croppa)
// import {baseurl} from '../src/api/url'
const qs = require('querystring')

var dateFormat = require('dateformat');
var now = new Date();
var timeStamp = dateFormat(now,'yyyymmddHHMM');
var checkV = 'poss' + timeStamp;
// var md5 = require('md5');
const sha256 = require("js-sha256").sha256
// var checkValue = md5(checkV).toUpperCase();
var checkValue = sha256(sha256(checkV+'szzt@002197')).toUpperCase();

/**
 * 设置默认语言 (为中文)
 */

Vue.use(VueI18n)
req.common.changeLang()



Vue.prototype.$httpzi = axios.create({
  baseURL: baseurl, // 接口根路径
  // baseURL: 'http://localhost:8081/tms/', // 接口根路径
  // 设置超时时间 毫秒
  timeout: 20000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  // 返回数据类型
  responseType: 'json', // default
  // 表明是否有跨域请求
  withCredentials: false,
  transformRequest: [function (data) {
    // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
    // data = qs.stringify(data)
    let options = {
      'condition': {},
      'pageNum': '',
      'numPerPage': '',
      'orderField': '',
      'orderDirection': 'desc',
      'pageFlag': '1',
      'timestamp': timeStamp,
      'checkvalue': checkValue
    }
    // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
    // data = qs.stringify(data)
    if (!data || typeof data === undefined) {
      data = {}
    }
    // 如果是带上传的表单
    if (typeof data.upload !== undefined && data.upload === true) {
      let jsondata = {
        token: 'szzttmsinterface=='
      }
      let formElement = document.getElementById(data.formElement)
      var formData = new FormData(formElement)
      if (typeof data.uploadData !== undefined && typeof data.uploadData === 'object') {
        for (let item in data.uploadData) {
          formData.set(item, data.uploadData[item])
        }
      }
      if (typeof data.areaid !== undefined && data.areaid !== '') {
        formData.append('areaid', data.areaid)
      }
      formData.append('jsondata', JSON.stringify(jsondata))
      return formData
    }
    data.token = 'szzttmsinterface==' // 'kW5YkgncB0mRCpLq9hv6VQ=='
    let nObj
    if (typeof data.write !== undefined && data.write === true) {
      nObj = data
      delete data.write
    } else {
      nObj = Object.assign(options, data)
    }
    let request = {}
    request.jsondata = JSON.stringify(nObj)
    request = qs.stringify(request)
    return request
  }],
  transformResponse: [function (data) {
    // 这里提前处理返回的数据
    //alert(JSON.stringify(data))
    if (typeof data === 'string') { // IE下返回字符串
      return JSON.parse(data)
    }
    return data
  }]
})


// 拦截 axios 请求前的 处理
axios.interceptors.request.use(function (config){

  // 把token添加到每个请求的body中
  var token = null;
  var lang = null;
  if (localStorage.getItem("user")) token = localStorage.getItem("user")
  if (localStorage.getItem("system_lang")) lang = localStorage.getItem("system_lang")
  if (!config.data) config.data = {}
  config.data['token'] = token;
  config.data['language'] = lang;

  return config;
}, function (error){
  //console.log("请求失败拦截")
  // 请求失败的处理
  return Promise.reject(error);
});

// http response 拦截器 || response.data.status == '400'
axios.interceptors.response.use(

  response => {
    if (response.data && (response.data.status == '600')) {
      router.replace({
        path: '/login'
      })
      return response;
    } else {
      return response;
    }
  },
  error => {
    return Promise.reject(error)   // 返回接口返回的错误信息
  });


Vue.prototype.req = req

Vue.use(ElementUI)
Vue.use(ztApi)
// Vue.use(Vuex)
Vue.use(Rs)
Vue.use(Wrqs)
Vue.use(WGMethods)
Vue.config.productionTip = false

let logos = localStorage.getItem('logo')
store.dispatch('setHomeLogo', logos)




router.beforeEach((to, from, next) => {

  /////渠道商状态维护
  if (to.path == '/channels' &&
  (from.path=='/channels/newchannel'||
  from.path=='/channels/editchannel'||
  from.path=='/channels/channel-detail')
   ) {
    store.dispatch('setIsRcMcpath', true)
  } else {
    store.dispatch('setIsRcMcpath', false)
  }

  if (from.path === "/terList"){
    var get = localStorage.getItem("timer");
    clearInterval(get)
  }
  if (from.path === "/log"){
    var gets = localStorage.getItem("timers");
    clearInterval(gets)
  }
  if (to.path === '/login') {
    console.log('退出登录')
    // localStorage.clear()
    // window.location.reload(true);
    localStorage.removeItem("iaAuth")
    //localStorage.removeItem("system_lang")
    store.dispatch('setInitRouter',"false")
    localStorage.removeItem("roleList")
    localStorage.removeItem("localMenuData")

  }

  let token = localStorage.getItem('user') || null
  // 有用户token,to.path不等于登录页面
  //

  if (token && to.path !== '/login') {

    console.log('有用户token, to.path不等于登录页面')
    // =================
    //   合法登录过的用户
    // =================

    async function resolvingRouterData (roleList = [], data = []) {
      function ge (roleList, data) {
        data.forEach((item) => {
          let menu = Object.assign({}, item)
          menu.component = require(`@/components/${item.component}.vue`)
          if (!menu.meta) {
            menu.meta = {}
          }

          if (menu.superId !== 0) {
            menu.children = []
            if (item.children) {
              ge(menu.children, item.children)
            }
          }
          roleList.push(menu)
        })
      }

      console.log('resolvingRouterData')
      ge(roleList, data)
    }

    // 请求后台接口, 获取当前用户所有的可访问权限
    var getMenuList = function () {
      return new Promise(function (resolve, reject) {
        axios.post(`${baseurl}/menu/menuList.do`, {token: localStorage.getItem('user')}).then(res => {
          resolve(res.data.data)
        })
      })
    }

    // 解析
    var setResolvingRouterData = function (list, rrr) {
      return new Promise(function (resolve, reject) {
        // var rrr = []
        console.log('获取到路由信息')
        resolvingRouterData(rrr, list)

        router.addRoutes(rrr)
        store.dispatch('setRouters', rrr)
        store.dispatch('setInitRouter', "true")
        console.log('end setData...')
        resolve()
      })
    }

    var start = async function () {
      // 在这里使用起来就像同步代码那样直观
      console.log('start_开始设置vue路由');

      let loginTag = localStorage.getItem('loginTag') || null
      let dbMenuData;
      if (loginTag) {
        console.log('用登录标识,需要重新请求接口获取最新的菜单信息')
        dbMenuData = await getMenuList()
        localStorage.removeItem('loginTag')
        localStorage.setItem('localMenuData', JSON.stringify(dbMenuData))
      } else {
        console.log('没有用户登录标志')
        let localMenuDataObject = localStorage.getItem('localMenuData') || null

        if (!localMenuDataObject) {
          console.log('localStorage 也没有 localMenuData的数据')
          dbMenuData = await getMenuList()
          localStorage.setItem('localMenuData', JSON.stringify(dbMenuData))
        } else {
          dbMenuData = JSON.parse(localMenuDataObject)
        }
      }

      let rrr = []
      await setResolvingRouterData(dbMenuData, rrr)

      router.addRoutes(rrr)
      store.dispatch('setRouters', rrr)
      store.dispatch('setInitRouter', "true")
      console.log('end_开始设置vue路由');
      // window.routeLoading.close()

      // await setUlTip()

    };

    if (!store.getters.isInitRouter || store.getters.isInitRouter !== "true") {
      start()
    } else {
      console.error('没有 inInitRouter')
    }

    anIFrameUrl()
    setUlTip()

    //next()
  } // end 合法登录用户处理
  else {
    // console.log('没有用户token, 证明是没有通过登录授权或者丢失登录token')
    // 没有用户token, 证明是没有通过登录授权或者丢失登录token
    if (to.path === '/login') {
      console.log('to.path等于/login')
      //next()
      setUlTip()
    } else {
      Vue.prototype.$message({message: Vue.t('app_misstokentip'), type: 'warning'})
      next('/login')
    }
  }



 function setUlTip () {
  // 上传拦截
  if( window[from.path])
  {
    var pkg = Vue.prototype.$plang[localStorage.system_lang]
    var tip = pkg.tip
    var ct = pkg.upTip
    var wsure = pkg.sure
    var wcans = pkg.cancel
    Vue.prototype.$confirm(ct, tip, {
      confirmButtonText: wsure,
      cancelButtonText: wcans,
      type: 'warning'
    }).then(() => {
      next()
    }).catch(() => {
      return false
    })
  } else {
    console.log('调用next()..')
    next()
  }
 }

 function anIFrameUrl () {
    var params = to.path.split('@url=')
    if (params.length == 2) {
      var url = params[1]
      url = url.replace('@', '?')
      store.dispatch('setGurl',url)
      // alert(store.getters.gIfurl)
    }
 }

})

var lang = localStorage.system_lang
var tt = ''
switch(lang) {
  case 'zh_cn':
    tt = '智能POS终端管理平台'
    break
  case 'en':
    tt = 'TMS Terminal management system'
    break
  case 'ko':
    tt = 'TMS 터미널 관리 시스템'
    break
  case 'ru':
    tt = 'Суко  терминал системы управления '
    break
  // case 'japan':
  //   tt = 'スマートPOS端末管理プラットフォーム'
  //   break
}
document.title = tt


new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js